import { observer } from 'mobx-react-lite';
import {
  Image,
  Header,
  Table,
  Divider,
  Icon,
  Popup,
  Pagination,
  PaginationProps,
} from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import HistoryDetailsHeader from './HistoryDetailsHeader';
import { useEffect, useState } from 'react';
import LoadingComponent from '../../../../app/layout/LoadingComponent';
import '../../../../app/common/MediaQuery/responsive-view-page.css';
import HistoryAttachment from './HistoryAttachment';
import HistoryModalComponent from '../../../../app/common/modals/HistoryModalComponent';
import { HistoryViewItemLevel } from '../../../../app/models/history';

function HistoryDetails() {
  const {
    activityStore: {
      selectedActivity: activity,
      loadAttachmentHistory,
      loadVoiceClipHistory,
      historyAttachmentFiles,
      fileDataVoice,
    },
    modalStore,
    commonStore,
    viewStore: {
      viewPageHistoryAlone,
      viewPageHistory,
      historyDetails,
      historyDetailsCount,
      historyLoader,
    },
    userStore,
  } = useStore();

  const [postsPerPage] = useState(4);
  const [pageNumber, setPageNumber] = useState(1);

  const paginateFn = (_e: any, data: any) => {
    setPageNumber(data);
    viewPageHistoryAlone({
      itemId: activity?.id,
      pageNo: data,
      pageSize: 4,
    });
  };

  useEffect(() => {
    if (
      userStore.user?.customerName !== 'NFAI' ||
      window.innerWidth > 1025 ||
      window.innerWidth < 1020
    ) {
      viewPageHistory({
        itemId: activity?.id,
        pageNo: pageNumber || 1,
        pageSize: 4,
      });
    }
    // eslint-disable-next-line
  }, [fileDataVoice, historyAttachmentFiles, activity?.id]);

  const openVoiceModal = (ids: string) => {
    loadVoiceClipHistory(ids);
    modalStore.openSmallModal(
      <>
        <HistoryModalComponent />
      </>,
    );
  };

  const changeDateTime = (data: string) => {
    return new Date(data).toLocaleString();
  };

  const openAttachmentModal = (ids: string) => {
    loadAttachmentHistory(ids);
    modalStore.openSmallModal(
      <>
        <HistoryAttachment />
      </>,
    );
  };
  const dataShow = (
    <Table basic="very" celled collapsing columns={16}>
      <Table.Body>
        {historyDetails?.map((a: HistoryViewItemLevel) => (
          <Table.Row key={a?.id}>
            <Table.Cell>
              <Image
                src={a?.url || '/assets/user.png'}
                rounded
                size="mini"
                onError={(img: any) => (img.target.src = '/assets/user.png')}
              />
            </Table.Cell>
            <Table.Cell width={2}>
              <Header as="h4" image>
                <Header.Content>
                  {a?.username}
                  <Header.Subheader>
                    {changeDateTime(a?.dateTime)}
                  </Header.Subheader>
                </Header.Content>
              </Header>
            </Table.Cell>
            <Table.Cell width={9}>{a.status}</Table.Cell>
            <Table.Cell width={4}>
              {a?.photos?.length > 0 && (
                <Icon
                  style={{
                    marginLeft: '5px',
                    cursor: 'pointer',
                  }}
                  onClick={() => openAttachmentModal(a.id)}
                  name="attach"
                />
              )}
              {a?.files?.length > 0 && (
                <Icon
                  style={{
                    marginLeft: '5px',
                    cursor: 'pointer',
                  }}
                  name="play"
                  onClick={() => openVoiceModal(a.id)}
                />
              )}
              {a?.comments?.length > 0 && (
                <Popup
                  content={a?.comments}
                  trigger={
                    <Icon
                      style={{
                        marginLeft: '5px',
                        cursor: 'pointer',
                      }}
                      name="comments"
                    />
                  }
                />
              )}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );

  if (historyLoader) return <LoadingComponent />;

  return (
    <div className="activity-detail">
      <div>
        <HistoryDetailsHeader />
      </div>
      {commonStore.filterModeTwo?.includes('AVLAVD05') ? (
        <></>
      ) : (
        <>
          {(userStore.user?.customerName !== 'NFAI' ||
            window.innerWidth > 1025 ||
            window.innerWidth < 1020) && (
            <div
              className={
                commonStore.filterModeZero?.includes('AVLAVD05')
                  ? 'component-isDisabled'
                  : ''
              }
            >
              <div className="activityhistorysmall">
                <Divider horizontal>
                  <Header color="teal" as="h4">
                    <Icon name="suitcase" />
                    History
                  </Header>
                </Divider>
                {dataShow}
              </div>
              {Math.ceil(historyDetailsCount / postsPerPage) > 1 && (
                <div className="activity-detail-footer">
                  <div>
                    <Pagination
                      className="user-tracker-small"
                      pointing
                      secondary
                      defaultActivePage={pageNumber}
                      totalPages={Math.ceil(historyDetailsCount / postsPerPage)}
                      onPageChange={(e: any, data: PaginationProps) =>
                        paginateFn(e, data.activePage)
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default observer(HistoryDetails);
